// 3rd-party modules
import 'reflect-metadata';
import camelcaseKeys from 'camelcase-keys';
import { Expose, plainToInstance } from 'class-transformer';

export class AccountDevice {
  @Expose()
  public id?: string;
  @Expose()
  public activeConnections?: number | null = null;
  @Expose()
  public blockedAt?: string;
  @Expose()
  public blockedUntil?: string | null = null;
  @Expose()
  public connectionStatus?: string | null = null;
  @Expose()
  public name?: string | null = null;
  @Expose()
  public deviceType?: string | null = null;
  @Expose()
  public excludedUntil?: string | null = null;
  @Expose()
  public isBlocked?: boolean;
  @Expose()
  public isDhcp?: boolean;
  @Expose()
  public isVpn?: boolean;
  @Expose()
  public vpnKiboshDeviceId?: string | null = null;
  @Expose()
  public vpnIsConnected?: boolean;
  @Expose()
  public vpnLongitude?: string | null = null;
  @Expose()
  public vpnLatitude?: string | null = null;
  @Expose()
  public vpnGpsUpdatedAt?: string | null = null;
  @Expose()
  public isExcluded?: boolean;
  @Expose()
  public detectedMalware?: AccountDeviceDomainListLog[] = [];
  @Expose()
  public detectedExplicit?: AccountDeviceDomainListLog[] = [];
  @Expose()
  public ip?: string | null = null;
  @Expose()
  public isWifi?: boolean;
  @Expose()
  public pingMs?: number | null = null;
  @Expose()
  public staticIp?: string | null = null;
  @Expose()
  public wifiBand?: string | null = null;
  @Expose()
  public wifiSignal?: number | null = null;
  @Expose()
  public numSchedules?: number | null = null;
  @Expose()
  public numActiveSchedules?: number | null = null;
  @Expose()
  public loggingEnabled?: number | null = null;
  @Expose()
  public groupId?: string | null = null;

  @Expose()
  public numSetFilters?: number | null = null;
  @Expose()
  public numSetFiltersWithSchedule?: number | null = null;
  @Expose()
  public numCustomFilters?: number | null = null;
  @Expose()
  public numCustomFiltersWithSchedule?: number | null = null;


  @Expose()
  public updatedAt?: string;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(AccountDevice, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(AccountDevice, camelcaseKeys(data, { deep: true }) as AccountDevice[], { excludeExtraneousValues: true });
  }
}

export class AccountDeviceActivityLog {
  @Expose()
  public domain?: string;
  @Expose()
  public queryTime?: Date;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(AccountDeviceActivityLog, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(AccountDeviceActivityLog, camelcaseKeys(data, { deep: true }) as AccountDeviceActivityLog[], { excludeExtraneousValues: true });
  }
}

export class AccountDeviceActivityFrequencyLog {
  @Expose()
  public domain?: string;
  @Expose()
  public queryTimes?: Date[];
  @Expose()
  public queryData?: any[];
  @Expose()
  public percent?: number;
  @Expose()
  public count?: number;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(AccountDeviceActivityFrequencyLog, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(AccountDeviceActivityFrequencyLog, camelcaseKeys(data, { deep: true }) as AccountDeviceActivityFrequencyLog[], { excludeExtraneousValues: true });
  }
}

export class AccountDeviceBandwidthLog {
  @Expose()
  public clientMac?: string;
  @Expose()
  public intervalDownloadBandwidth?: string;
  @Expose()
  public intervalUploadBandwidth?: string;
  @Expose()
  public intervalEnd?: Date;
  @Expose()
  public name?: string;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(AccountDeviceBandwidthLog, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(AccountDeviceBandwidthLog, camelcaseKeys(data, { deep: true }) as AccountDeviceBandwidthLog[], { excludeExtraneousValues: true });
  }
}

export class AccountLatencyLog {
  @Expose()
  public pingMs?: number;
  @Expose()
  public pingTimestamp?: Date;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(AccountLatencyLog, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(AccountLatencyLog, camelcaseKeys(data, { deep: true }) as AccountLatencyLog[], { excludeExtraneousValues: true });
  }
}






export class AccountDeviceSchedule {
  public id?: string;
  public fromDay?: string;
  public fromTime?: string | null;
  public enabled?: string;
  public toDay?: string;
  public toTime?: string | null;
  public repeats?: string;
  public fromHour?: number | null;
  public fromMinute?: number | null;
  public fromAmPm?: string | null;
  public toHour?: number | null;
  public toMinute?: number | null;
  public toAmPm?: string | null;
  public activeDays?: string;


  constructor(rawData?: any) {
    if (rawData) {
      this.id = rawData.id || null;
      this.enabled = rawData.enabled || "1";
      this.repeats = rawData.repeats || null;
      this.fromDay = rawData.from_day || null;
      this.toDay = rawData.to_day || null;
      // eslint-disable-next-line eqeqeq
      this.fromHour = rawData.from_hour || null;
      this.toHour = rawData.to_hour || null;
      this.fromMinute = rawData.from_minute || null;
      this.toMinute = rawData.to_minute || null;
      this.fromAmPm = rawData.from_am_pm || null;
      this.toAmPm = rawData.to_am_pm || null;
      this.activeDays = rawData.active_days || null;
      this.fromTime = rawData.from_hour && rawData.from_minute && rawData.from_am_pm ? `${rawData.from_hour}:${rawData.from_minute} ${rawData.from_am_pm}`: null;
      this.toTime = rawData.to_hour && rawData.to_minute && rawData.to_am_pm ? `${rawData.to_hour}:${rawData.to_minute} ${rawData.to_am_pm}`: null;
    }
  }

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(AccountDeviceSchedule, data, { excludeExtraneousValues: true });
  }

  static toArrayOfClass(data: any[]): AccountDeviceSchedule[] {
    const accountDeviceSchedules: AccountDeviceSchedule[] = [];

    if (data != null) {
      for (const accountDeviceSchedule of data) {
        accountDeviceSchedules.push(new AccountDeviceSchedule(accountDeviceSchedule));
      }
    }

    return accountDeviceSchedules;
  }
}

export class AccountDeviceDomainListLog {
  @Expose()
  public domain?: string;
  @Expose()
  public lastQueried?: Date;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(AccountDeviceDomainListLog, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(AccountDeviceDomainListLog, camelcaseKeys(data, { deep: true }) as AccountDeviceDomainListLog[], { excludeExtraneousValues: true });
  }
}
